import $ from "modules/jquery_global";
import select2 from "select2";

if (!$.fn.select2) {
  select2(window, $);
}

document.addEventListener("turbolinks:load", () => {
  const coursePairSelection = $("#course-pair-selection");
  if (coursePairSelection.length === 0) {
    return;
  }

  coursePairSelection.select2({
    placeholder: "Search for a course to link",
    theme: "bootstrap4",
  });

  coursePairSelection.on('change', function(e){
    if ($(this).val()){
      $("#link-course-submit").prop('disabled', false);
    }
  });
});
